//import Swagger from 'swagger-client';
//import TruckingReactAPI from '../../lib/TruckingReactAPI';
import { handleError, error, receive, request } from '../../lib/Utils';
import fetch from 'isomorphic-fetch';
import SwaggerApi, { callApi } from '../../lib/SwaggerApi';

//let SwaggerApi = new Swagger('/api/docs');

export const SELF = {
  REQUEST: "SELF_REQUEST",
  SUCCESS: "SELF_SUCCESS",
  FAILURE: "SELF_FAILURE"
};

export const UPDATE_SELF = {
  REQUEST: "UPDATE_SELF_REQUEST",
  SUCCESS: "UPDATE_SELF_SUCCESS",
  FAILURE: "UPDATE_SELF_FAILURE"
};

export const PASSWORD_UPDATE_SELF = {
  REQUEST: "PASSWORD_UPDATE_SELF_REQUEST",
  SUCCESS: "PASSWORD_UPDATE_SELF_SUCCESS",
  FAILURE: "PASSWORD_UPDATE_SELF_FAILURE"
};

export function getSelf(callback) {
  return callApi(null, "Users", "getSelf", SELF, callback);
}

export function updateSelf(parameters, callback) {
  return callApi(parameters, "Self", "updateSelf", UPDATE_SELF, callback);
}

export const passwordUpdateSelf = (formData, callback = () => false) => {
  return callApi({
    passwordUpdateSelfBody: formData
  }, "Self", "passwordUpdateSelf", PASSWORD_UPDATE_SELF, callback);
};


// WEBPACK FOOTER //
// ./src/containers/Header/HeaderActions.js